const getEditTableInitialsValue = (selectedColumnsData) => {
  return {
    date_format: selectedColumnsData?.data?.date_format ?? "",
  }
};

export default getEditTableInitialsValue;
